import gql from 'graphql-tag';

export const mutationSendAccountInvitation = gql`
  mutation sendAccountInvitation (
    $email: String!
  ) {
    sendAccountInvitation (
      email: $email
    )
  }
`;
export default mutationSendAccountInvitation;
